import { render, staticRenderFns } from "./ColorControls.vue?vue&type=template&id=70f110f8&scoped=true"
import script from "./ColorControls.vue?vue&type=script&lang=js"
export * from "./ColorControls.vue?vue&type=script&lang=js"
import style0 from "./ColorControls.vue?vue&type=style&index=0&id=70f110f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f110f8",
  null
  
)

export default component.exports